import React, {useState} from 'react';
import {PlusOutlined, DeleteOutlined, SaveOutlined, ArrowRightOutlined} from "@ant-design/icons";
import $ from 'jquery'
import {NavLink} from "react-router-dom";
import AddIstemolchi from "./istemolchilar/AddIstemolchi";

function Istemolchilar() {

    const season = localStorage.getItem('sfr-hm-season')
    const [istemolchilar, setIstemolchilar] = useState(localStorage.getItem('sfr-hm-istemolchilar') ? JSON.parse(localStorage.getItem('sfr-hm-istemolchilar')) : [])
    const [maydonlar, setMaydonlar] = useState(localStorage.getItem('sfr-hm-'+season+'-maydon') ? JSON.parse(localStorage.getItem('sfr-hm-'+season+'-maydon')) : [])
    const [forDelete, setForDelete] = useState([])
    const [addPopup, setAddPopup] = useState(false)
    const checkedHandler = (index, i, d, v) => {
        if (v) {
            $("input[type=checkbox]").each(function () {
                if ($(this)[0].className != 'checkbox' + i) {
                    $(this)[0].checked = false
                }
            })
            setForDelete([index, d])
        } else {
            setForDelete([])
        }
    }
    const deleteHandler = () => {
        let istemolchi = [...istemolchilar]
        let gms = istemolchi[forDelete[0]].gms
        let ngms = gms.filter(gm => gm != forDelete[1])
        let maydon = {...maydonlar}
        const istid = istemolchi[forDelete[0]].istemolchi_id
        if (ngms.length) {
            istemolchi[forDelete[0]].gms = ngms
            if(maydon['i'+istid]){
                if(maydon['i'+istid][forDelete[1]]){
                    let newIstMaydon = maydon['i'+istid]
                    delete newIstMaydon[forDelete[1]]
                    maydon['i'+istid] = newIstMaydon
                }
            }
        } else {
            istemolchi = istemolchi.filter((is, i) => i != forDelete[0])
            delete maydon['i'+istid]
            // maydon = Object.keys(maydon)
            //     .filter(key => key!='i'+istid)
            //     .reduce((obj, key) => {
            //         obj[key] = maydon[key];
            //         return obj;
            //     }, {});
        }
        setMaydonlar(maydon)
        setIstemolchilar(istemolchi)
        setForDelete([])
        $("input[type=checkbox]").each(function () {
            $(this)[0].checked = false
        })
    }
    const data = () => {
        let c = 0;
        if (istemolchilar.length) {
            return istemolchilar.map((istemolchi, index) => {
                return istemolchi.gms.map((d, i) => {
                    return <tr key={i}>
                        <td>
                            <input
                                type="checkbox"
                                className={"checkbox" + i}
                                onChange={e => checkedHandler(index, i, d, e.target.checked)}
                            />
                        </td>
                        <td>
                            {++c}
                        </td>
                        <td>
                            {istemolchi.name}
                        </td>
                        <td>
                            {istemolchi.mname}
                        </td>
                        <td>
                            {d}
                        </td>
                    </tr>
                })
            })
        }
    }
    return (
        <div className="row">
            <div className="col-12">
                <h3 className="my-4 text-center">Istemolchilar</h3>
            </div>
            <div className="col-12">
                <div className="row">
                    <div className="col-7">
                        <div className="flextableblock">
                            <table className="table table-bordered  change_gidromodule_table">
                                <thead>
                                <tr>
                                    <th>o</th>
                                    <th>T/r</th>
                                    <th>Istemolchi</th>
                                    <th>Suv manbasi</th>
                                    <th>Gidromodul</th>
                                </tr>
                                </thead>
                                <tbody>
                                {data()}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    {
                        addPopup
                            ?<div className="addPopup">
                                <div className="p-box ">
                                    <AddIstemolchi setAddPopup={setAddPopup}/>
                                </div>
                            </div>
                            :null
                    }
                    <div className="col-3 offset-1 d-flex flex-column justify-content-between pb-5">
                        <div>
                            <div className="my-4">
                                <button
                                    style={{width: "170px"}}
                                    onClick={()=>setAddPopup(true)}
                                    className="btn btn-sm btn-outline-primary d-flex align-items-center"
                                >
                                    Yangi istemolchi&nbsp;&nbsp;<PlusOutlined/>
                                </button>
                            </div>
                            <div className="my-4">
                                <button style={{width: "170px"}} disabled={!forDelete.length}
                                        className="btn btn-sm btn-outline-danger d-flex align-items-center"
                                        onClick={() => deleteHandler()}>Istemolchini o'chirish&nbsp;&nbsp;
                                    <DeleteOutlined/></button>
                            </div>
                        </div>
                        <div>
                            <button className="btn btn-sm btn-outline-success d-flex align-items-center" onClick={() => {
                                localStorage.setItem('sfr-hm-istemolchilar', JSON.stringify(istemolchilar))
                                localStorage.setItem('sfr-hm-'+season+'-maydon', JSON.stringify(maydonlar))
                                window.location = '/sfr/gidromodul/new/insert/ste'
                            }}>
                                Keyingisi&nbsp;&nbsp;<ArrowRightOutlined/>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Istemolchilar;